import classNames from 'classnames'
import { JSX, useRef } from 'react'

import styles from './Radio.module.scss'

export interface IRadioProps {
  /**
   * A Class name for component root node
   */
  className?: string
  /**
   * Caption for radio button.
   */
  label?: string | JSX.Element
  /**
   * Is RadioButton checked
   */
  checked: boolean
  /**
   * RadioButton value
   */
  value: string
  /**
   * RadioButton name
   */
  name?: string
  /**
   * Handler for RadioButton click event
   */
  onChange?: (e: any) => void
  /**
   * Spacing size under the RadioButton
   */
  margin?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  /**
   * Inner spacing size
   */
  padding?: boolean
  /**
   * RadioButton has inline-flex layout
   */
  inline?: boolean
  /**
   * RadioButton is not available for interaction
   */
  disabled?: boolean
}

export const Radio = ({
  className,
  label,
  checked,
  onChange,
  value,
  name,
  margin = 'none',
  padding = false,
  inline = false,
  disabled = false,
}: IRadioProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const clickHandle = (ref: any) => {
    ref.current.click()
  }

  return (
    <div
      className={classNames(
        styles.root,
        {
          [styles[`margin-${margin}`]]: margin,
          [styles['root--padding']]: padding,
          [styles['root--inline']]: inline,
        },
        className || ''
      )}
    >
      <div
        data-testid={'radioRoot'}
        className={classNames(styles.inner, disabled ? styles['inner--disabled'] : '')}
        onMouseDown={(e) => {
          e.preventDefault()
          e.stopPropagation()
          clickHandle(inputRef)
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <input
          ref={inputRef}
          className={styles.control}
          value={value}
          name={name}
          data-testid={'radioInput'}
          checked={checked}
          type={'radio'}
          onChange={(e) => onChange && onChange(e.target.value)}
          disabled={disabled}
        />
        <div
          className={classNames(
            styles.icon,
            checked && styles['icon--checked'],
            disabled && styles['icon--disabled']
          )}
        />
        {label && <div className={styles.label}>{label}</div>}
      </div>
    </div>
  )
}
